export enum OwnershipTypes {
    Coop = 24,
    Condo = 26,
    Condop = 27,
    Townhouse = 225,
    Rental = 25
}